import { RefObject, useEffect } from 'react';

export const useResizeObserver = <T extends HTMLElement>(ref: RefObject<T>, callback: () => void) => {
    useEffect(() => {
        if (!ref.current) return;

        const resizeObserver = new ResizeObserver(() => {
            callback();
        });

        resizeObserver.observe(ref.current);

        return () => {
            resizeObserver.disconnect();
        };
    }, [ref, callback]);
};
